// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"styles_appContainer__24CC1"};